import styled from "styled-components";
import breakpoints, {breakpointsRaw} from "./breakpoints";
import {ItemTitleLarge} from "./titles";

export const OnImageInfoWrapper = styled.div`
  bottom: 0;
  width: 100%;
  position: relative;
  margin: -100px 0 0 0;
  box-sizing: border-box;

  .flag span {
    margin: 0;
  }

  @media screen and (max-width: ${breakpointsRaw.desktop - 1}px) {
    h2, .flag, span {
      margin: 0;
      padding: 0 1rem;
      box-sizing: border-box;
      background-color: #000;
    }
    .flag {
      margin-top: -1px;
      margin-bottom: -1px;

      span {
        padding: 0.3em 0.75em 0.2em;
      }
    }
    h2 {
      padding: 0.475rem 1rem 1rem;

      span {
        padding: 0 0.5em 0 0;
      }
    }
  }

  &:before {
    background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 100%);
    height: 100px;
    display: block;
    content: '';
    position: relative;
  }

  @media ${breakpoints.desktop} {
    padding: 5em 1em 1em;
    background-color: transparent;
    position: absolute;
    background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.95) 100%);
    &:before {
      display: none;
    }
  }
`;

export const OnImageTitle = styled(ItemTitleLarge)`
  margin: 0.25em 0 -0.2em;
  font-size: 18px;
  span {
    display: inline;
    color: #fff;
  }

  svg path {
    fill: #fff;
  }
`;
